import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UsersService {
    constructor(private http: HttpClient) {}

    createUser(userData: any) {
        return this.http.post(`${environment.apiBack}usuarios`, userData);
    }

    getUsers(page: number, pageSize: number) {
        const params = new HttpParams().set('page', page.toString()).set('pageSize', pageSize.toString());
        return this.http.get(`${environment.apiBack}usuarios`, { params });
    }

    getUserById(userId: number) {
        return this.http.get(`${environment.apiBack}usuarios/${userId}`);
    }

    updateUser(userId: number, userData: any) {
        return this.http.put(`${environment.apiBack}usuarios/${userId}`, userData);
    }

    /**
     * Actualiza los consentimientos de tratamiento de datos del usuario.
     * PATCH /api/usuarios/{id}/consentimientos
     */
    actualizarConsentimientos(userId: number, consentimientos: {
        acepta_datos_biometricos?: boolean;
        acepta_geolocalizacion?: boolean;
    }) {
        return this.http.patch(`${environment.apiBack}usuarios/${userId}/consentimientos`, consentimientos);
    }

    saveFaceDescriptor(userId: number, faceDescriptor: number[] | null) {
        return this.http.post(`${environment.apiBack}usuarios/${userId}/face-descriptor`, {
            face_descriptor: faceDescriptor
        });
    }

    verifyFaceDescriptor(userId: number, faceDescriptor: number[]) {
        return this.http.post(`${environment.apiBack}usuarios/${userId}/verify-face`, {
            face_descriptor: faceDescriptor
        });
    }

    cambiarSede(userId: number, codigo: string) {
        return this.http.post(`${environment.apiBack}usuarios/${userId}/cambiar-sede`, {
            codigo: codigo
        });
    }

    validarSedeByCodigo(codigo: string) {
        return this.http.get(`${environment.apiBack}sedes/codigo/${codigo}`);
    }

    getUsuariosByEntidad(entidadId: number | string) {
        return this.http.get(`${environment.apiBack}entidades/${entidadId}/usuarios`);
    }

    cambiarEstadoInvitacion(userId: number, invitacion: 'confirmada' | 'cancelada') {
        return this.http.patch(`${environment.apiBack}usuarios/${userId}/invitacion`, { invitacion });
    }

    getUsersBySedeOrEntidad(entidadId: any, sedeId?: any) {
        let params = new HttpParams().set('entidad_id', entidadId?.toString() ?? '');
        if (sedeId != null) {
            params = params.set('sede_id', sedeId.toString());
        }
        return this.http.get(`${environment.apiBack}users-by-sede-or-entidad`, { params });
    }

    getProfilePhoto(userId: number) {
        return this.http.get(`${environment.apiBack}usuarios/${userId}/foto-perfil`);
    }

    uploadProfilePhoto(userId: number, file: File) {
        const formData = new FormData();
        formData.append('foto', file);
        return this.http.post(`${environment.apiBack}usuarios/${userId}/foto-perfil`, formData);
    }

    toggleActivo(userId: number) {
        return this.http.patch(`${environment.apiBack}usuarios/${userId}/toggle-activo`, {});
    }
}
